export const PackTicker = ({ packs, onPick }) => {
  const Row = ({ hidden = false }) => (
    <div className="flex shrink-0" aria-hidden={hidden ? "true" : undefined}>
      {packs.map((p, i) => (
        <button
          key={p.id + "-" + i}
          type="button"
          data-testid={`ticker-pack-${p.id}`}
          onClick={() => onPick && onPick(p.id)}
          className="mx-4 my-3 flex cursor-pointer items-center gap-4 rounded-2xl border border-brand-line/70 bg-white p-3 shadow-sm transition-colors duration-300 hover:border-brand-red/50"
        >
          <span className="flex h-32 w-56 items-center justify-center overflow-hidden rounded-xl bg-brand-cream">
            <img src={p.img} alt={p.name} className="h-full w-full object-contain" />
          </span>
          <span className="w-28 pr-2 text-left font-display text-base leading-snug text-brand-ink">
            {p.name}
          </span>
        </button>
      ))}
    </div>
  );

  if (!packs.length) {
    return (
      <div data-testid="pack-ticker" className="border-y border-brand-line/60 bg-white/50 py-10">
        <p className="text-center font-mono text-[11px] uppercase tracking-[0.28em] text-brand-muted">
          Official pack artwork updating — new packs will appear here shortly
        </p>
      </div>
    );
  }

  return (
    <div data-testid="pack-ticker" className="group edge-fade overflow-hidden py-2">
      <div className="marquee-track flex w-max">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
};

export default PackTicker;
